import styled from "styled-components";
import theme from "../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-family: var(--font-sans);
  margin-right: auto;
  margin-left: 7vw;
  margin-top: 3vh;
  .title {
    font-size: ${theme.fontSize.md};
    font-weight: 600;
    color: black;
  }
  .sub-title {
    font-size: ${theme.fontSize.mm};
    font-weight: 400;
    color: #5f6368;
  }
  body[data-admin-shell] & {
    margin-left: 32px;
    margin-top: 28px;
    .title {
      font-size: 28px;
      font-weight: 500;
      color: var(--ink);
      letter-spacing: -0.3px;
    }
  }
`;
